<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8ypnvS/tc-custom/9781504078603.jpg?1738699792258" alt="This image is the cover for the book Country of the Blind"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Country of the Blind
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Thirty-three science fiction and fantasy stories from the celebrated author of such classics as <i>The War of the Worlds</i>, <i>The Times Machine</i>, and <i>The Invisible Man</i>.</b></p> Venture to strange worlds from the imagination of H. G. Wells with this collection of tales of science fiction and fantasy. Witness the darker side of humanity in “The Jilting of Jane” and “The Cone.” Learn what a man does when he faces fear itself in a haunted house in “The Red Room.” Travel to an Ecuadorian mountain community deprived of sight in “The Country of the Blind.” Find a curio inside an antique shop in London’s West End that allows you to see Mars in “The Crystal Egg.” Float down the Amazon on a Brazilian gunboat as a captain and his crew fight to save a village from terrifyingly evolved ants. These are just a few of the unusual journeys awaiting readers inside this compilation from one of the greatest science fiction writers in history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. G. Wells
      </h2>
      
      <p class="authorDescription body article">The son of a professional cricketer and a lady&rsquo;s maid, H. G. Wells (1866&ndash;1946) served apprenticeships as a draper and a chemist&rsquo;s assistant before winning a scholarship to the prestigious Normal School of Science in London. While he is best remembered for his groundbreaking science fiction novels, including <I>The Time Machine</I>, <I>The War of the Worlds</I>, <I>The Invisible Man</I>, and <I>The Island of Doctor Moreau</I>, Wells also wrote extensively on politics and social matters and was one of the foremost public intellectuals of his day.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70f19912